<script setup>
import {
    BookmarkIcon,
    CloudArrowDownIcon,
    FireIcon,
    HomeIcon,
    MagnifyingGlassIcon,
    UserCircleIcon,
} from '@heroicons/vue/24/outline'
import { Facebook } from 'lucide-vue-next'
import {usePage} from "@inertiajs/vue3";
import {useWpaInstallStore} from "@/Stores/WpaInstallStore";
import { ref } from 'vue'
import AppLink from "@/Components/AppLink.vue";

const pwaInstallStore = useWpaInstallStore();
const settings = ref(usePage().props.settings);

const enable_pwa = settings.value.enable_pwa;
</script>

<template>
	<nav class="max-w-xl mx-auto flex justify-evenly">
		<AppLink :class="{'animate-selected' : route().current('homepage')}" :href="route('homepage')" aria-label="Homepage"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300">
			<HomeIcon class="h-8"/>
		</AppLink>

		<AppLink :class="{'animate-selected' : route().current('top-posts')}" :href="route('top-posts')" aria-label="Top Posts"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300">
			<FireIcon class="h-8 text-primary-500 animate-bounce"/>
		</AppLink>

		<AppLink :class="{'animate-selected' : route().current('discover')}" :href="route('discover')" aria-label="Discover Posts and Creators"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300">
			<MagnifyingGlassIcon class="h-8"/>
		</AppLink>

		<button v-if="enable_pwa && pwaInstallStore.enabled" aria-label="Download App"
		        class=" p-4 w-full h-full flex items-center justify-center text-dark-300 "
		        @click="pwaInstallStore.showInAppInstallPromotion('Menu Bounce - Green')">
			<CloudArrowDownIcon class="h-8 text-green-600 animate-bounce"/>
		</button>

		<AppLink :class="{'animate-selected' : route().current('collection.index')}" :href="route('collection.index')" aria-label="Collections"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300">
			<BookmarkIcon class="h-8"/>
		</AppLink>

		<a v-if="settings.general.fb_page" href="https://www.facebook.com/profile.php?id=61583480750734" target="_blank" rel="noopener noreferrer"
		   aria-label="Facebook" class="p-4 w-full h-full flex items-center justify-center">
			<Facebook class="h-8 w-8 text-[#1877F2]"/>
		</a>

		<AppLink v-if="usePage().props.auth.user" :class="{'animate-selected' : route().current('profile.index')}" :href="route('profile.index')"
		      aria-label="My Account"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300">
			<UserCircleIcon class="h-8"/>
		</AppLink>
		<AppLink v-else :class="{'animate-selected' : route().current('login')}" :href="route('login')" aria-label="Login/Register"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300">
			<UserCircleIcon class="h-8"/>
		</AppLink>
	</nav>
</template>
